<div class="absolute inset-0 flex min-w-0 flex-col overflow-auto">
    <!-- Main -->
    <div class="flex-1 flex flex-col">
        <!-- Header -->
        <div class="bg-default flex flex-col items-start px-4 py-6 sm:flex-row sm:items-center sm:justify-between md:px-6 flex-shrink-0">
            <!-- Title -->
            <div>
                <div class="text-3xl font-extrabold leading-none tracking-tight">All Venues</div>
                <div class="text-secondary ml-0.5 font-medium text-sm">
                    <span>View all venues across all companies</span>
                </div>
            </div>
            
            <!-- Search and Actions -->
            <div class="mt-4 sm:mt-0 flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                <!-- Search Bar -->
                <div class="relative w-full sm:w-60">
                    <div class="relative">
                        <mat-icon class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm">search</mat-icon>
                        <input type="text" 
                               [(ngModel)]="searchQuery"
                               (ngModelChange)="onSearchInput()"
                               (focus)="showSearchDropdown = filteredVenues.length > 0 && searchQuery.trim() !== ''"
                               (blur)="onSearchBlur()"
                               placeholder="Search venues..."
                               class="w-full pl-8 pr-8 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white text-sm">
                        
                        <!-- Clear button -->
                        <button *ngIf="searchQuery" 
                                (click)="clearSearch()"
                                class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                            <mat-icon class="text-xs">close</mat-icon>
                        </button>
                    </div>
                    
                    <!-- Search Dropdown -->
                    <div *ngIf="showSearchDropdown && filteredVenues.length > 0" 
                         class="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-80 overflow-y-auto">
                        <div class="p-2">
                            <div class="text-xs font-semibold text-gray-500 px-2 py-1">Results ({{filteredVenues.length}})</div>
                            <div class="divide-y divide-gray-100">
                                <div *ngFor="let venue of filteredVenues" 
                                     (click)="selectVenue(venue)"
                                     class="px-2 py-2 hover:bg-blue-50 cursor-pointer transition-colors duration-150">
                                    <div class="flex items-center">
                                        <div class="w-6 h-6 bg-gray-100 rounded flex items-center justify-center mr-2">
                                            <mat-icon class="text-gray-400" style="font-size: 16px;">location_on</mat-icon>
                                        </div>
                                        <div class="flex-1 min-w-0">
                                            <div class="font-medium text-gray-900 truncate text-sm">{{venue.name}}</div>
                                            <div class="text-xs text-gray-500 truncate">
                                                {{venue.location?.placeName || 'No location'}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Selected Venue Badge -->
                    <div *ngIf="selectedVenue" class="mt-2">
                        <div class="inline-flex items-center bg-blue-50 text-blue-700 px-2 py-1 rounded-full text-xs">
                            <mat-icon class="mr-1" style="font-size: 14px;">location_on</mat-icon>
                            <span class="font-medium truncate max-w-[150px]">{{selectedVenue.name}}</span>
                            <button (click)="clearSearch()" class="ml-1 text-blue-500 hover:text-blue-700">
                                <mat-icon class="text-xs">close</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                
                <!-- Refresh Button -->
                <button mat-button 
                        (click)="refreshVenues()"
                        class="inline-flex items-center justify-center px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 text-gray-700 text-sm">
                    <mat-icon class="mr-1 text-sm">refresh</mat-icon>
                    Refresh
                </button>
            </div>
        </div>

        <!-- Venues Table -->
        <div class="px-4 md:px-6 pb-6 flex-1 overflow-auto">
            <!-- Search Info -->
            <div *ngIf="isSearchActive" class="mb-4">
                <div class="bg-blue-50 border border-blue-200 rounded-lg p-3">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center">
                            <mat-icon class="text-blue-600 mr-2 text-sm">info</mat-icon>
                            <span class="text-blue-700 text-sm">
                                Showing results for "{{searchQuery}}"
                            </span>
                        </div>
                        <button mat-button 
                                (click)="clearSearch()"
                                class="text-blue-600 hover:text-blue-800 text-sm">
                            Clear
                        </button>
                    </div>
                </div>
            </div>

            <!-- Venues Table -->
            <div *ngIf="recentVenuesDataSource.data.length > 0" class="mb-6 w-full">
                <div class="bg-white rounded-lg shadow overflow-hidden w-full">
                    <!-- Table Container -->
                    <div class="overflow-x-auto w-full">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-48">
                                        Venue
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-28">
                                        Verified
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-28">
                                        Onboarded
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-28">
                                        Featured
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-52">
                                        Location
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-36">
                                        Hours
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-24">
                                        Status
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-40">
                                        Company
                                    </th>
                                    <th scope="col" class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap w-32">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <ng-container *ngFor="let venue of recentVenuesDataSource.data; trackBy: trackByFn">
                                    <!-- Main Row -->
                                    <tr id="venue-{{venue._id}}" class="hover:bg-gray-50">
                                        <!-- Venue Column -->
                                        <td class="px-4 py-4">
                                            <div class="flex items-center">
                                                <div class="flex-shrink-0 h-8 w-8 bg-gray-100 rounded-lg flex items-center justify-center">
                                                    <mat-icon class="text-gray-400 text-sm">location_on</mat-icon>
                                                </div>
                                                <div class="ml-3">
                                                    <div class="text-sm font-medium text-gray-900 truncate max-w-[180px]">{{venue.name}}</div>
                                                    <div class="text-xs text-gray-500">
                                                        {{ venue.createdAt | date:'shortDate' }}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        <!-- Verified Column -->
                                        <td class="px-4 py-4">
                                            <span class="inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium"
                                                  [ngClass]="{
                                                    'bg-green-100 text-green-800': venue.verified,
                                                    'bg-gray-100 text-gray-800': !venue.verified
                                                  }">
                                                <mat-icon *ngIf="venue.verified" class="mr-1" style="font-size: 12px;">check_circle</mat-icon>
                                                {{ venue.verified ? 'Verified' : 'Not Verified' }}
                                            </span>
                                        </td>

                                        <!-- Onboarded Column -->
                                        <td class="px-4 py-4">
                                            <span class="inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium"
                                                  [ngClass]="{
                                                    'bg-blue-100 text-blue-800': venue.onBoarded,
                                                    'bg-gray-100 text-gray-800': !venue.onBoarded
                                                  }">
                                                <mat-icon class="mr-1" style="font-size: 12px;">{{ venue.onBoarded ? 'done_all' : 'pending_actions' }}</mat-icon>
                                                {{ venue.onBoarded ? 'Onboarded' : 'Not Onboarded' }}
                                            </span>
                                        </td>

                                        <!-- Featured Column -->
                                        <td class="px-4 py-4">
                                            <span data-testid="featured-status-badge"
                                                  class="inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium"
                                                  [ngClass]="{
                                                    'bg-amber-100 text-amber-900': venue.featured,
                                                    'bg-gray-100 text-gray-800': !venue.featured
                                                  }">
                                                <mat-icon class="mr-1" style="font-size: 12px;">workspace_premium</mat-icon>
                                                {{ venue.featured ? 'Featured' : 'Not Featured' }}
                                            </span>
                                        </td>

                                        <!-- Location Column -->
                                        <td class="px-4 py-4">
                                            <div class="text-sm text-gray-900 truncate max-w-[200px]">{{venue.location?.placeName || 'N/A'}}</div>
                                            <div class="text-xs text-gray-500 truncate max-w-[200px]">
                                                {{venue.location?.placeAddress || 'No address'}}
                                            </div>
                                        </td>

                                        <!-- Operating Hours Column -->
                                        <td class="px-4 py-4">
                                            <div class="text-sm text-gray-900">
                                                <span *ngIf="venue.timing && venue.timing.length > 0">
                                                    {{getOperatingDaysCount(venue)}} days
                                                </span>
                                                <span *ngIf="!venue.timing || venue.timing.length === 0">
                                                    Not set
                                                </span>
                                            </div>
                                            <div class="text-xs text-gray-500 truncate max-w-[140px]">
                                                <span *ngIf="venue.timing && venue.timing.length > 0">
                                                    {{getFirstOperatingTime(venue)}}
                                                </span>
                                            </div>
                                        </td>

                                        <!-- Status Column -->
                                        <td class="px-4 py-4">
                                            <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                                                  [ngClass]="{
                                                    'bg-red-100 text-red-800': venue.status === 'inactive',
                                                    'bg-green-100 text-green-800': venue.status === 'active',
                                                    'bg-gray-100 text-gray-800': !venue.status
                                                  }">
                                                {{ venue.status === 'active' ? 'Active' : 
                                                   venue.status === 'inactive' ? 'Inactive' : 'N/A' }}
                                            </span>
                                        </td>

                                        <!-- Company Column -->
                                        <td class="px-4 py-4">
                                            <div class="text-sm text-gray-900 truncate max-w-[160px]">
                                                {{venue.companyName || 'Unknown'}}
                                            </div>
                                        </td>

                                        <!-- Actions Column -->
                                        <td class="px-4 py-4">
                                            <div class="flex justify-center items-center space-x-2">
                                                <!-- Edit button -->
                                                <button mat-icon-button 
                                                        matTooltip="Edit"
                                                        class="text-blue-600 hover:bg-blue-50"
                                                        (click)="editVenue(venue, $event)">
                                                    <mat-icon style="font-size: 20px;">edit</mat-icon>
                                                </button>
                                                
                                                <!-- Verify/Unverify button -->
                                                <button mat-icon-button 
                                                        matTooltip="{{venue.verified ? 'Mark as Not Verified' : 'Mark as Verified'}}"
                                                        class="{{venue.verified ? 'text-green-600 hover:bg-green-50' : 'text-gray-600 hover:bg-gray-100'}}"
                                                        (click)="toggleVerification(venue._id, $event)">
                                                    <mat-icon style="font-size: 20px;">
                                                        {{venue.verified ? 'check_circle' : 'cancel'}}
                                                    </mat-icon>
                                                </button>

                                                <!-- Feature/Unfeature button -->
                                                <button mat-icon-button
                                                        [disabled]="isFeaturedUpdatePending(venue._id)"
                                                        matTooltip="{{venue.featured ? 'Remove Featured Status' : 'Mark as Featured'}}"
                                                        class="{{venue.featured ? 'text-amber-600 hover:bg-amber-50' : 'text-gray-600 hover:bg-gray-100'}}"
                                                        (click)="toggleFeatured(venue._id, $event)">
                                                    <mat-icon style="font-size: 20px;">
                                                        workspace_premium
                                                    </mat-icon>
                                                </button>

                                                <!-- Delete button -->
                                                <button *ngIf="canPerformDestructiveActions" mat-icon-button
                                                        matTooltip="Delete"
                                                        class="text-red-600 hover:bg-red-50"
                                                        (click)="deleteVenue(venue._id, venue.name, $event)">
                                                    <mat-icon style="font-size: 20px;">delete</mat-icon>
                                                </button>
                                                
                                                <!-- Expand/Collapse button -->
                                                <button mat-icon-button 
                                                        matTooltip="Details"
                                                        class="text-blue-600 hover:bg-blue-50"
                                                        (click)="toggleRow(venue._id); $event.stopPropagation()">
                                                    <mat-icon *ngIf="expandedVenueId !== venue._id" style="font-size: 20px;">expand_more</mat-icon>
                                                    <mat-icon *ngIf="expandedVenueId === venue._id" style="font-size: 20px;">expand_less</mat-icon>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>

                                    <!-- Expanded Details Row -->
                                    <tr *ngIf="expandedVenueId === venue._id" class="bg-blue-50">
                                        <td colspan="9" class="px-4 py-4">
                                            <div class="flex justify-end mb-2">
                                                <button mat-button 
                                                        (click)="editVenue(venue, $event)"
                                                        class="text-blue-600 hover:text-blue-800 text-sm">
                                                    <mat-icon class="mr-1 text-sm">edit</mat-icon>
                                                    Edit Venue
                                                </button>
                                            </div>
                                            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                <!-- Venue Details -->
                                                <div class="bg-white rounded-lg p-3 shadow-sm border border-gray-200">
                                                    <h3 class="text-sm font-semibold text-gray-900 mb-3 flex items-center">
                                                        <mat-icon class="mr-2 text-blue-600 text-sm">location_on</mat-icon>
                                                        Venue Details
                                                    </h3>
                                                    <div class="space-y-2">
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400 text-sm">title</mat-icon>
                                                            <span class="text-xs font-medium text-gray-600 mr-2">Name:</span>
                                                            <span class="text-xs font-semibold truncate">{{venue.name}}</span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400 text-sm">verified_user</mat-icon>
                                                            <span class="text-xs font-medium text-gray-600 mr-2">Verification:</span>
                                                            <span [ngClass]="{
                                                                    'text-green-600 font-semibold': venue.verified,
                                                                    'text-gray-600': !venue.verified
                                                                  }" 
                                                                  class="text-xs">
                                                                {{ venue.verified ? 'Verified ✓' : 'Not Verified' }}
                                                            </span>
                                                            <button mat-button 
                                                                    (click)="toggleVerification(venue._id, $event)"
                                                                    class="ml-2 text-xs"
                                                                    [ngClass]="{
                                                                        'text-green-600 hover:text-green-800': !venue.verified,
                                                                        'text-red-600 hover:text-red-800': venue.verified
                                                                    }">
                                                                <mat-icon class="mr-1" style="font-size: 14px;">
                                                                    {{ venue.verified ? 'close' : 'check_circle' }}
                                                                </mat-icon>
                                                                {{ venue.verified ? 'Mark as Not Verified' : 'Mark as Verified' }}
                                                            </button>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400 text-sm">dashboard</mat-icon>
                                                            <span class="text-xs font-medium text-gray-600 mr-2">Onboarding:</span>
                                                            <span [ngClass]="{
                                                                    'text-blue-600 font-semibold': venue.onBoarded,
                                                                    'text-gray-600': !venue.onBoarded
                                                                  }" 
                                                                  class="text-xs">
                                                                {{ venue.onBoarded ? 'Onboarded ✓' : 'Not Onboarded' }}
                                                            </span>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-amber-600 text-sm">workspace_premium</mat-icon>
                                                            <span class="text-xs font-medium text-gray-600 mr-2">Featured:</span>
                                                            <span class="text-xs"
                                                                  [ngClass]="{
                                                                    'text-amber-700 font-semibold': venue.featured,
                                                                    'text-gray-600': !venue.featured
                                                                  }">
                                                                {{ venue.featured ? 'Featured' : 'Not Featured' }}
                                                            </span>
                                                            <button mat-button
                                                                    [disabled]="isFeaturedUpdatePending(venue._id)"
                                                                    (click)="toggleFeatured(venue._id, $event)"
                                                                    class="ml-2 text-xs"
                                                                    [ngClass]="{
                                                                        'text-amber-700 hover:text-amber-900': !venue.featured,
                                                                        'text-red-600 hover:text-red-800': venue.featured
                                                                    }">
                                                                <mat-icon class="mr-1" style="font-size: 14px;">
                                                                    workspace_premium
                                                                </mat-icon>
                                                                {{ venue.featured ? 'Remove Featured Status' : 'Mark as Featured' }}
                                                            </button>
                                                        </div>
                                                        <div class="flex items-center">
                                                            <mat-icon class="mr-2 text-gray-400 text-sm">schedule</mat-icon>
                                                            <span class="text-xs font-medium text-gray-600 mr-2">Status:</span>
                                                            <span [ngClass]="{
                                                                    'text-green-600': venue.status === 'active',
                                                                    'text-red-600': venue.status === 'inactive',
                                                                    'text-gray-600': !venue.status
                                                                  }" 
                                                                  class="text-xs font-medium">
                                                                {{ venue.status === 'active' ? 'Active' : 
                                                                   venue.status === 'inactive' ? 'Inactive' : 'Unknown' }}
                                                            </span>
                                                        </div>
                                                        <!-- Location moved here from Additional Information -->
                                                        <div>
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 14px;">location_on</mat-icon>
                                                                <span class="text-xs font-medium text-gray-600">Location:</span>
                                                            </div>
                                                            <div class="bg-gray-50 rounded-md p-2">
                                                            <div class="text-xs font-medium text-gray-900 truncate">
                                                                {{ venue.location?.placeName || 'N/A' }}
                                                            </div>
                                                            <div class="text-[11px] text-gray-500 leading-snug line-clamp-2">
                                                                {{ venue.location?.placeAddress || 'Address not available' }}
                                                            </div>
                                                        </div>

                                                        </div>
                                                        <div class="mt-3">
                                                            <div class="flex items-center">
                                                                <mat-icon class="mr-2 text-gray-400 text-sm">image_not_supported</mat-icon>
                                                                <span class="text-xs font-medium text-gray-600">No venue image available</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Additional Details -->
                                                <div class="bg-white rounded-lg p-3 shadow-sm border border-gray-200">
                                                    <h3 class="text-sm font-semibold text-gray-900 mb-3 flex items-center">
                                                        <mat-icon class="mr-2 text-green-600 text-sm">info</mat-icon>
                                                        Additional Information
                                                    </h3>
                                                    <div class="space-y-3">
                                                        <!-- Timing Details -->
                                                        <div>
                                                            <div class="flex items-center justify-between mb-1">
                                                                <div class="flex items-center">
                                                                    <mat-icon class="mr-2 text-gray-400" style="font-size: 14px;">schedule</mat-icon>
                                                                    <span class="text-xs font-medium text-gray-600">Operating Hours:</span>
                                                                </div>
                                                                <button *ngIf="venue.timing?.length > 3 && !showAllDays" 
                                                                        mat-button 
                                                                        (click)="toggleShowAllDays(); $event.stopPropagation()"
                                                                        class="text-blue-600 text-xs hover:text-blue-800">
                                                                    Show all {{venue.timing.length}} days
                                                                </button>
                                                                <button *ngIf="showAllDays && venue.timing?.length > 3" 
                                                                        mat-button 
                                                                        (click)="toggleShowAllDays(); $event.stopPropagation()"
                                                                        class="text-blue-600 text-xs hover:text-blue-800">
                                                                    Show less
                                                                </button>
                                                            </div>
                                                            <div class="space-y-1">
                                                                <div *ngFor="let day of getDaysToDisplay(venue)" class="flex justify-between text-xs">
                                                                    <span class="text-gray-600">{{ day.name }}</span>
                                                                    <span class="text-gray-900 font-medium" *ngIf="day.checked">
                                                                        {{ day.startTime }} - {{ day.endTime }}
                                                                    </span>
                                                                    <span class="text-gray-400" *ngIf="!day.checked">Closed</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Cancellation Policy -->
                                                        <div *ngIf="venue.cancellationPolicy?.enabled">
                                                            <div class="flex items-center mb-1">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 14px;">cancel</mat-icon>
                                                                <span class="text-xs font-medium text-gray-600">Cancellation Policy:</span>
                                                            </div>
                                                            <div class="space-y-1">
                                                                <div *ngFor="let rule of venue.cancellationPolicy?.rules" class="flex justify-between text-xs">
                                                                    <span class="text-gray-600">{{ rule.hoursBeforeBooking }} hours before</span>
                                                                    <span class="text-gray-900 font-medium">{{ rule.refundPercentage }}% refund</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <!-- Company Info - Now inline -->
                                                        <div class="flex items-center space-x-3 mt-6">
                                                            <mat-icon class="text-gray-400" style="font-size: 14px;">business</mat-icon>
                                                            <span class="text-xs font-medium text-gray-600">Company:</span>
                                                            <span class="inline-flex items-center bg-gray-100 text-gray-800 
                                                              px-2 py-0.5 rounded-full text-xs font-medium">
                                                              {{ venue.companyName || 'Unknown Company' }}
                                                           </span>

                                                        </div>


                                                        <!-- Dates - Now inline -->
                                                        <div class="pt-2 border-t border-gray-100">
                                                            <div class="flex items-center text-xs text-gray-500">
                                                                <mat-icon class="mr-2 text-gray-400" style="font-size: 14px;">calendar_today</mat-icon>
                                                                <div class="flex items-center space-x-4">
                                                                    <div class="flex items-center">
                                                                        <span class="font-medium mr-1">Created:</span>
                                                                        <span>{{ venue.createdAt | date:'shortDate' }}</span>
                                                                    </div>
                                                                    <div class="flex items-center">
                                                                        <span class="font-medium mr-1">Updated:</span>
                                                                        <span>{{ venue.updatedAt | date:'shortDate' }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>

                    <!-- Table Footer with Pagination -->
                    <div class="bg-gray-50 px-4 py-3 border-t border-gray-200">
                        <div class="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
                            <div class="text-xs text-gray-700">
                                Showing <span class="font-medium">{{recentVenuesDataSource.data.length}}</span> of 
                                <span class="font-medium">{{totalVenues}}</span> venues
                                <span *ngIf="isSearchActive" class="text-blue-600 ml-2">
                                    (Search Results)
                                </span>
                            </div>
                            
                            <mat-paginator [length]="totalVenues"
                                           [pageSize]="pageSize"
                                           [pageSizeOptions]="pageSizeOptions"
                                           [pageIndex]="currentPage"
                                           (page)="onPageChange($event)"
                                           aria-label="Select page"
                                           class="border-0 scale-90">
                            </mat-paginator>
                            
                            <button mat-button 
                                    (click)="refreshVenues()"
                                    class="text-blue-600 hover:text-blue-800 text-sm">
                                <mat-icon class="text-sm">refresh</mat-icon>
                                <span class="ml-1">Refresh</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="recentVenuesDataSource.data.length === 0" class="text-center py-8">
                <div class="inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 mb-3">
                    <mat-icon class="text-gray-400" style="width: 24px; height: 24px; font-size: 24px;">location_off</mat-icon>
                </div>
                <h3 class="text-base font-medium text-gray-900 mb-1">
                    {{ isSearchActive ? 'No matching venues found' : 'No venues found' }}
                </h3>
                <p class="text-gray-500 text-sm mb-3">
                    {{ isSearchActive ? 'Try a different search term' : 'There are no venues available.' }}
                </p>
                <button *ngIf="isSearchActive" 
                        mat-button 
                        (click)="clearSearch()"
                        class="text-blue-600 hover:text-blue-800 text-sm">
                    Clear Search
                </button>
            </div>
        </div>
    </div>
</div>
